// AUTO-GENERATED by sync-navigation.js — DO NOT EDIT

const sections = [
  {
    "key": "workspace",
    "label": "工作台",
    "iconKey": "desktop",
    "order": 10
  },
  {
    "key": "system",
    "label": "系统管理",
    "iconKey": "settings",
    "order": 20
  },
  {
    "key": "masterData",
    "label": "基础数据 · MASTER DATA",
    "iconKey": "database",
    "order": 30
  },
  {
    "key": "contractManagement",
    "label": "采购合同管理",
    "iconKey": "globe",
    "order": 40
  },
  {
    "key": "schedules",
    "label": "航班计划 · PLAN",
    "iconKey": "calendar",
    "order": 50
  },
  {
    "key": "operation",
    "label": "航班运行控制 · OCC",
    "iconKey": "plane",
    "order": 60
  },
  {
    "key": "uld",
    "label": "ULD 管理",
    "iconKey": "code-sandbox",
    "order": 70
  },
  {
    "key": "sales",
    "label": "销售管理",
    "iconKey": "shop",
    "order": 80
  },
  {
    "key": "mailHub",
    "label": "Mail Hub",
    "iconKey": "mail",
    "order": 80
  },
  {
    "key": "docCenter",
    "label": "文档中心",
    "iconKey": "folder",
    "order": 85
  },
  {
    "key": "settlement",
    "label": "结算管理",
    "iconKey": "account-book",
    "order": 90
  },
  {
    "key": "mailbox",
    "label": "我的邮箱",
    "iconKey": "mail",
    "order": 100
  },
  {
    "key": "tools",
    "label": "实用工具",
    "iconKey": "chart-bar",
    "order": 110
  }
];

const routes = [
  {
    "key": "businessDashboard",
    "path": "/workspace/business-dashboard",
    "sectionKey": "workspace",
    "frontend": "old",
    "menu": true,
    "menuLabel": "经营看板",
    "menuIconKey": "line-chart",
    "menuOrder": 15,
    "navigatePath": "/workspace/business-dashboard",
    "routePermission": "business_dashboard:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/workspace/business-dashboard"
    ],
    "openInNewTab": true
  },
  {
    "key": "notificationCenter",
    "path": "/workspace/notification-center",
    "sectionKey": "workspace",
    "frontend": "old",
    "menu": true,
    "menuLabel": "待办通知处理中心",
    "menuIconKey": "bell",
    "menuOrder": 20,
    "navigatePath": "/workspace/notification-center",
    "routePermission": "flight_operation:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/workspace/notification-center"
    ]
  },
  {
    "key": "portalAgentArtifacts",
    "path": "/agent-artifacts",
    "sectionKey": "workspace",
    "frontend": "new",
    "menu": true,
    "menuLabel": "Agent 产物",
    "menuIconKey": "file-text",
    "menuOrder": 25,
    "navigatePath": "/agent-artifacts",
    "routePermission": "agent_artifact:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/agent-artifacts"
    ]
  },
  {
    "key": "portalDocCenter",
    "path": "/doc-center",
    "sectionKey": "docCenter",
    "frontend": "new",
    "menu": true,
    "menuLabel": "文档中心",
    "menuIconKey": "file-text",
    "menuOrder": 10,
    "navigatePath": "/doc-center",
    "routePermission": null,
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/doc-center"
    ]
  },
  {
    "key": "portalSourcePartitions",
    "path": "/doc-center/source-partitions",
    "sectionKey": "docCenter",
    "frontend": "new",
    "menu": true,
    "menuLabel": "来源分区管理",
    "menuIconKey": "control",
    "menuOrder": 20,
    "navigatePath": "/doc-center/source-partitions",
    "routePermission": [
      "mail_hub:ops_view",
      "mail_hub:manage"
    ],
    "menuPermission": null,
    "permissionMatch": "any",
    "matchPatterns": [
      "/doc-center/source-partitions"
    ]
  },
  {
    "key": "users",
    "path": "/user-management",
    "sectionKey": "system",
    "frontend": "old",
    "menu": true,
    "menuLabel": "用户管理",
    "menuIconKey": "user",
    "menuOrder": 10,
    "navigatePath": "/user-management",
    "routePermission": "user:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/user-management"
    ]
  },
  {
    "key": "roles",
    "path": "/role-management",
    "sectionKey": "system",
    "frontend": "old",
    "menu": true,
    "menuLabel": "角色权限",
    "menuIconKey": "team",
    "menuOrder": 20,
    "navigatePath": "/role-management",
    "routePermission": "role:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/role-management"
    ]
  },
  {
    "key": "permissions",
    "path": "/permission-management",
    "sectionKey": "system",
    "frontend": "old",
    "menu": true,
    "menuLabel": "权限列表",
    "menuIconKey": "safety-certificate",
    "menuOrder": 30,
    "navigatePath": "/permission-management",
    "routePermission": "permission:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/permission-management"
    ]
  },
  {
    "key": "organizations",
    "path": "/organization-management",
    "sectionKey": "system",
    "frontend": "old",
    "menu": true,
    "menuLabel": "组织管理",
    "menuIconKey": "globe",
    "menuOrder": 35,
    "navigatePath": "/organization-management",
    "routePermission": "user:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/organization-management"
    ]
  },
  {
    "key": "auditLogs",
    "path": "/audit-logs",
    "sectionKey": "system",
    "frontend": "old",
    "menu": true,
    "menuLabel": "审计日志",
    "menuIconKey": "audit",
    "menuOrder": 37,
    "navigatePath": "/audit-logs",
    "routePermission": "audit:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/audit-logs"
    ]
  },
  {
    "key": "dashboardTemplates",
    "path": "/templates",
    "sectionKey": "system",
    "frontend": "old",
    "menu": true,
    "menuLabel": "Dashboard 模版",
    "menuIconKey": "layout",
    "menuOrder": 40,
    "navigatePath": "/templates",
    "routePermission": "dashboard_template:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/templates",
      "/templates/:templateId/design"
    ]
  },
  {
    "key": "dashboardTemplateEditor",
    "path": "/templates/:templateId/design",
    "sectionKey": "system",
    "frontend": "old",
    "menu": false,
    "activeMenuKey": "dashboardTemplates",
    "routePermission": "dashboard_template:update",
    "matchPatterns": [
      "/templates/:templateId/design"
    ]
  },
  {
    "key": "portalAgentToolPreview",
    "path": "/system/agent-tool-preview",
    "sectionKey": "system",
    "frontend": "new",
    "menu": true,
    "menuLabel": "Agent 视角审查台",
    "menuIconKey": "eye",
    "menuOrder": 45,
    "navigatePath": "/system/agent-tool-preview",
    "routePermission": "agent_tool:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/system/agent-tool-preview"
    ]
  },
  {
    "key": "screenControl",
    "path": "/operation/screen-control",
    "sectionKey": "tools",
    "frontend": "old",
    "menu": true,
    "menuLabel": "运营大屏控制",
    "menuIconKey": "monitor",
    "menuOrder": 10,
    "navigatePath": "/operation/screen-control",
    "routePermission": "operation:screen:manage",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/operation/screen-control"
    ]
  },
  {
    "key": "marketIntelligence",
    "path": "/market-intelligence",
    "sectionKey": "tools",
    "frontend": "old",
    "menu": true,
    "menuLabel": "市场情报",
    "menuIconKey": "market-intelligence",
    "menuOrder": 15,
    "navigatePath": "/market-intelligence",
    "routePermission": "market_intelligence:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/market-intelligence"
    ]
  },
  {
    "key": "airportDepartureBoard",
    "path": "/airport-departure/board",
    "sectionKey": "tools",
    "frontend": "old",
    "menu": true,
    "menuLabel": "机场离港观察",
    "menuIconKey": "eye",
    "menuOrder": 16,
    "navigatePath": "/airport-departure/board",
    "routePermission": "airport_departure:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/airport-departure/board"
    ]
  },
  {
    "key": "marketIntelligenceDocument",
    "path": "/market-intelligence/document",
    "frontend": "old",
    "menu": false,
    "pageLabel": "市场情报文档",
    "routePermission": "market_intelligence:read",
    "permissionMatch": "all",
    "activeMenuKey": "marketIntelligence",
    "matchPatterns": [
      "/market-intelligence/document"
    ]
  },
  {
    "key": "marketIntelligenceEntity",
    "path": "/market-intelligence/entity",
    "frontend": "old",
    "menu": false,
    "pageLabel": "市场情报实体",
    "routePermission": "market_intelligence:read",
    "permissionMatch": "all",
    "activeMenuKey": "marketIntelligence",
    "matchPatterns": [
      "/market-intelligence/entity"
    ]
  },
  {
    "key": "flightMonitorDemo",
    "path": "/operation/flight-monitor-demo",
    "sectionKey": "tools",
    "frontend": "old",
    "menu": true,
    "menuLabel": "航班监控 (DEMO)",
    "menuIconKey": "radar-chart",
    "menuOrder": 20,
    "navigatePath": "/operation/flight-monitor-demo",
    "routePermission": "flight_operation:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/operation/flight-monitor-demo"
    ]
  },
  {
    "key": "rampChecklist",
    "path": "/ramp-checklist",
    "sectionKey": "tools",
    "frontend": "old",
    "menu": true,
    "menuLabel": "过站检查单",
    "menuIconKey": "check-square",
    "menuOrder": 25,
    "navigatePath": "/ramp-checklist",
    "routePermission": "flight_operation:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/ramp-checklist"
    ]
  },
  {
    "key": "rampChecklistDetail",
    "path": "/ramp-checklist/:legId",
    "sectionKey": "tools",
    "frontend": "old",
    "menu": false,
    "activeMenuKey": "rampChecklist",
    "routePermission": "flight_operation:read",
    "matchPatterns": [
      "/ramp-checklist/:legId"
    ]
  },
  {
    "key": "sankeyFlowDemo",
    "path": "/sankey-flow-demo",
    "sectionKey": "tools",
    "frontend": "old",
    "menu": true,
    "menuLabel": "航班事务流向图（DEMO）",
    "menuIconKey": "node-index",
    "menuOrder": 40,
    "navigatePath": "/sankey-flow-demo",
    "routePermission": "demo:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/sankey-flow-demo"
    ]
  },
  {
    "key": "templateDrivenEmailDemo",
    "path": "/template-driven-email-demo",
    "sectionKey": "tools",
    "frontend": "old",
    "menu": true,
    "menuLabel": "模板驱动邮件编辑器",
    "menuIconKey": "mail",
    "menuOrder": 50,
    "navigatePath": "/template-driven-email-demo",
    "routePermission": "email_demo:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/template-driven-email-demo"
    ]
  },
  {
    "key": "airports",
    "path": "/master-data/airports",
    "sectionKey": "masterData",
    "frontend": "old",
    "menu": true,
    "menuLabel": "机场",
    "menuIconKey": "environment",
    "menuOrder": 10,
    "navigatePath": "/master-data/airports",
    "routePermission": "masterdata:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/master-data/airports"
    ]
  },
  {
    "key": "flightRoutes",
    "path": "/master-data/flight-routes",
    "sectionKey": "masterData",
    "frontend": "old",
    "menu": true,
    "menuLabel": "航路",
    "menuIconKey": "node-index",
    "menuOrder": 20,
    "navigatePath": "/master-data/flight-routes",
    "routePermission": "masterdata:read",
    "menuPermission": "flight_route:read",
    "permissionMatch": "all",
    "matchPatterns": [
      "/master-data/flight-routes"
    ]
  },
  {
    "key": "flightRoutesV2",
    "path": "/master-data/flight-routes-v2",
    "sectionKey": "masterData",
    "frontend": "new",
    "menu": true,
    "menuLabel": "航路 V2",
    "menuIconKey": "node-index",
    "menuOrder": 25,
    "navigatePath": "/master-data/flight-routes-v2",
    "routePermission": "flight_route:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/master-data/flight-routes-v2"
    ]
  },
  {
    "key": "flightLegs",
    "path": "/master-data/flight-legs",
    "sectionKey": "masterData",
    "frontend": "old",
    "menu": true,
    "menuLabel": "航段",
    "menuIconKey": "swap",
    "menuOrder": 30,
    "navigatePath": "/master-data/flight-legs",
    "routePermission": "masterdata:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/master-data/flight-legs"
    ]
  },
  {
    "key": "aircraft",
    "path": "/master-data/aircraft",
    "sectionKey": "masterData",
    "frontend": "old",
    "menu": true,
    "menuLabel": "飞机",
    "menuIconKey": "app-store",
    "menuOrder": 40,
    "navigatePath": "/master-data/aircraft",
    "routePermission": "masterdata:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/master-data/aircraft"
    ]
  },
  {
    "key": "emailTemplates",
    "path": "/master-data/email-templates",
    "sectionKey": "masterData",
    "frontend": "old",
    "menu": true,
    "menuLabel": "邮件模板",
    "menuIconKey": "file-text",
    "menuOrder": 50,
    "navigatePath": "/master-data/email-templates",
    "routePermission": "masterdata:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/master-data/email-templates"
    ]
  },
  {
    "key": "emailGroups",
    "path": "/master-data/email-groups",
    "sectionKey": "masterData",
    "frontend": "old",
    "menu": true,
    "menuLabel": "邮箱地址与分组",
    "menuIconKey": "inbox",
    "menuOrder": 60,
    "navigatePath": "/master-data/email-groups",
    "routePermission": "masterdata:read",
    "menuPermission": "email_group:read",
    "permissionMatch": "all",
    "matchPatterns": [
      "/master-data/email-groups"
    ]
  },
  {
    "key": "products",
    "path": "/master-data/products",
    "sectionKey": "masterData",
    "frontend": "old",
    "menu": true,
    "menuLabel": "产品",
    "menuIconKey": "app-store",
    "menuOrder": 70,
    "navigatePath": "/master-data/products",
    "routePermission": "masterdata:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/master-data/products"
    ]
  },
  {
    "key": "measurementUnits",
    "path": "/master-data/measurement-units",
    "sectionKey": "masterData",
    "frontend": "old",
    "menu": true,
    "menuLabel": "计量单位",
    "menuIconKey": "calculator",
    "menuOrder": 75,
    "navigatePath": "/master-data/measurement-units",
    "routePermission": "masterdata:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/master-data/measurement-units"
    ]
  },
  {
    "key": "productBundles",
    "path": "/master-data/product-bundles",
    "sectionKey": "masterData",
    "frontend": "old",
    "menu": true,
    "menuLabel": "产品套装",
    "menuIconKey": "app-store",
    "menuOrder": 80,
    "navigatePath": "/master-data/product-bundles",
    "routePermission": "masterdata:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/master-data/product-bundles"
    ]
  },
  {
    "key": "exchangeRates",
    "path": "/master-data/exchange-rates",
    "sectionKey": "masterData",
    "frontend": "old",
    "menu": true,
    "menuLabel": "汇率管理",
    "menuIconKey": "dollar",
    "menuOrder": 90,
    "navigatePath": "/master-data/exchange-rates",
    "routePermission": "masterdata:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/master-data/exchange-rates"
    ]
  },
  {
    "key": "scenarioContextList",
    "path": "/agent/scenario-contexts",
    "sectionKey": "masterData",
    "frontend": "old",
    "menu": true,
    "menuLabel": "场景化上下文管理",
    "menuIconKey": "control",
    "menuOrder": 100,
    "navigatePath": "/agent/scenario-contexts",
    "routePermission": "agent:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/agent/scenario-contexts"
    ]
  },
  {
    "key": "agentVariantRuleList",
    "path": "/agent/variant-rules",
    "sectionKey": "masterData",
    "frontend": "old",
    "menu": true,
    "menuLabel": "Agent变体路由规则",
    "menuIconKey": "branches",
    "menuOrder": 110,
    "navigatePath": "/agent/variant-rules",
    "routePermission": "agent:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/agent/variant-rules"
    ]
  },
  {
    "key": "businessPartners",
    "path": "/contract-management/business-partners",
    "sectionKey": "sales",
    "frontend": "old",
    "menu": true,
    "menuLabel": "客户",
    "menuIconKey": "team",
    "menuOrder": 5,
    "navigatePath": "/contract-management/business-partners",
    "routePermission": "business_partner:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/contract-management/business-partners"
    ]
  },
  {
    "key": "supplierContracts",
    "path": "/contract-management/supplier-contracts",
    "sectionKey": "contractManagement",
    "frontend": "new",
    "menu": true,
    "menuLabel": "供应商合同",
    "menuIconKey": "file-protect",
    "menuOrder": 20,
    "navigatePath": "/contract-management/supplier-contracts",
    "routePermission": "contract:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/contract-management/supplier-contracts"
    ]
  },
  {
    "key": "supplierContractDetail",
    "path": "/contract-management/supplier-contracts/detail",
    "sectionKey": "contractManagement",
    "frontend": "new",
    "menu": false,
    "activeMenuKey": "supplierContracts",
    "routePermission": "contract:read",
    "permissionMatch": "all",
    "matchPatterns": [
      "/contract-management/supplier-contracts/detail"
    ]
  },
  {
    "key": "supplierContractItems",
    "path": "/contract-management/supplier-contract-items",
    "sectionKey": "contractManagement",
    "frontend": "old",
    "menu": false,
    "activeMenuKey": "supplierContracts",
    "routePermission": "contract:read",
    "permissionMatch": "all",
    "matchPatterns": [
      "/contract-management/supplier-contract-items"
    ]
  },
  {
    "key": "relationshipDashboard",
    "path": "/contract-management/relationship-dashboard",
    "sectionKey": "contractManagement",
    "frontend": "new",
    "menu": true,
    "menuLabel": "关联查询系统",
    "menuIconKey": "search",
    "menuOrder": 30,
    "navigatePath": "/contract-management/relationship-dashboard",
    "routePermission": "contract:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/contract-management/relationship-dashboard"
    ]
  },
  {
    "key": "fuelPriceManagement",
    "path": "/contract-management/fuel-prices",
    "sectionKey": "contractManagement",
    "frontend": "old",
    "menu": true,
    "menuLabel": "燃油价格管理",
    "menuIconKey": "dollar",
    "menuOrder": 40,
    "navigatePath": "/contract-management/fuel-prices",
    "routePermission": "contract:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/contract-management/fuel-prices"
    ]
  },
  {
    "key": "marketReferencePriceManagement",
    "path": "/contract-management/fuel-prices/market-reference",
    "sectionKey": "contractManagement",
    "frontend": "old",
    "menu": false,
    "activeMenuKey": "fuelPriceManagement",
    "routePermission": "contract:read",
    "matchPatterns": [
      "/contract-management/fuel-prices/market-reference"
    ]
  },
  {
    "key": "vendorCrm",
    "path": "/contract-management/vendor-crm",
    "sectionKey": "contractManagement",
    "frontend": "new",
    "menu": true,
    "menuLabel": "供应商 CRM",
    "menuIconKey": "solution",
    "menuOrder": 15,
    "navigatePath": "/contract-management/vendor-crm",
    "routePermission": "vendor_crm:read",
    "menuPermission": "vendor_crm:read",
    "permissionMatch": "all",
    "matchPatterns": [
      "/contract-management/vendor-crm"
    ]
  },
  {
    "key": "vendorCrmV2",
    "path": "/contract-management/vendor-crm-v2",
    "sectionKey": "contractManagement",
    "frontend": "new",
    "menu": true,
    "menuLabel": "供应商 CRM V2",
    "menuIconKey": "solution",
    "menuOrder": 15.5,
    "navigatePath": "/contract-management/vendor-crm-v2",
    "routePermission": "vendor_crm:read",
    "menuPermission": "vendor_crm:read",
    "permissionMatch": "all",
    "matchPatterns": [
      "/contract-management/vendor-crm-v2"
    ]
  },
  {
    "key": "vendorCrmCreate",
    "path": "/contract-management/vendor-crm/new",
    "sectionKey": "contractManagement",
    "frontend": "new",
    "menu": false,
    "activeMenuKey": "vendorCrm",
    "routePermission": "vendor_crm:write",
    "matchPatterns": [
      "/contract-management/vendor-crm/new"
    ]
  },
  {
    "key": "vendorCrmAlerts",
    "path": "/contract-management/vendor-crm/alerts",
    "sectionKey": "contractManagement",
    "frontend": "new",
    "menu": false,
    "activeMenuKey": "vendorCrm",
    "routePermission": "vendor_crm:read",
    "matchPatterns": [
      "/contract-management/vendor-crm/alerts"
    ]
  },
  {
    "key": "vendorCrmDetail",
    "path": "/contract-management/vendor-crm/:id",
    "sectionKey": "contractManagement",
    "frontend": "old",
    "menu": false,
    "activeMenuKey": "vendorCrm",
    "routePermission": "vendor_crm:read",
    "matchPatterns": [
      "/contract-management/vendor-crm/:id"
    ]
  },
  {
    "key": "vendorCrmDetailPortal",
    "path": "/contract-management/vendor-crm/detail",
    "sectionKey": "contractManagement",
    "frontend": "new",
    "menu": false,
    "activeMenuKey": "vendorCrm",
    "routePermission": "vendor_crm:read",
    "matchPatterns": [
      "/contract-management/vendor-crm/detail"
    ]
  },
  {
    "key": "mawbStock",
    "path": "/mawb/stock",
    "sectionKey": "sales",
    "frontend": "old",
    "menu": true,
    "menuLabel": "主单号管理",
    "menuIconKey": "profile",
    "menuOrder": 10,
    "navigatePath": "/mawb/stock",
    "routePermission": "mawb:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/mawb/stock",
      "/mawb/stock/:id"
    ]
  },
  {
    "key": "mawbStockDetail",
    "path": "/mawb/stock/:id",
    "sectionKey": "sales",
    "frontend": "old",
    "menu": false,
    "activeMenuKey": "mawbStock",
    "routePermission": "mawb:read",
    "matchPatterns": [
      "/mawb/stock/:id"
    ]
  },
  {
    "key": "outbox",
    "path": "/mailbox/outbox",
    "sectionKey": "mailbox",
    "frontend": "old",
    "menu": true,
    "menuLabel": "发件箱",
    "menuIconKey": "send",
    "menuOrder": 10,
    "navigatePath": "/mailbox/outbox",
    "routePermission": "mail:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/mailbox/outbox"
    ]
  },
  {
    "key": "autoForward",
    "path": "/mailbox/auto-forward",
    "sectionKey": "mailbox",
    "frontend": "old",
    "menu": true,
    "menuLabel": "自动转发监控",
    "menuIconKey": "eye",
    "menuOrder": 20,
    "navigatePath": "/mailbox/auto-forward",
    "routePermission": "mail:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/mailbox/auto-forward"
    ]
  },
  {
    "key": "salesRevenueManagementLegacy",
    "path": "/sales/revenue-management",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "activeMenuKey": "salesRevenueRoutes",
    "routePermission": "sales:revenue:read",
    "matchPatterns": [
      "/sales/revenue-management"
    ]
  },
  {
    "key": "salesRevenueRoutes",
    "path": "/sales/routes",
    "sectionKey": "sales",
    "frontend": "old",
    "menu": true,
    "menuLabel": "销售航线池",
    "menuIconKey": "node-index",
    "menuOrder": 20,
    "navigatePath": "/sales/routes",
    "routePermission": "sales:revenue:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/sales/routes"
    ]
  },
  {
    "key": "salesRevenueContracts",
    "path": "/sales/charter-contracts/:contractId?",
    "sectionKey": "sales",
    "frontend": "old",
    "menu": true,
    "menuLabel": "销售合同",
    "menuIconKey": "file-protect",
    "menuOrder": 30,
    "navigatePath": "/sales/charter-contracts",
    "routePermission": "sales:revenue:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/sales/charter-contracts",
      "/sales/charter-contracts/:contractId"
    ]
  },
  {
    "key": "salesTransportBookings",
    "path": "/sales/transport-bookings",
    "sectionKey": "sales",
    "frontend": "new",
    "menu": true,
    "menuLabel": "运输需求 Booking",
    "menuIconKey": "file-text",
    "menuOrder": 35,
    "navigatePath": "/sales/transport-bookings",
    "routePermission": "sales:transport-booking:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/sales/transport-bookings",
      "/sales/transport-bookings/new",
      "/sales/transport-bookings/detail"
    ]
  },
  {
    "key": "salesFlightAttribution",
    "path": "/sales/flight-attribution",
    "sectionKey": "sales",
    "frontend": "new",
    "menu": true,
    "menuLabel": "客户归属",
    "menuIconKey": "team",
    "menuOrder": 36,
    "navigatePath": "/sales/flight-attribution",
    "routePermission": "sales:flight-attribution:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/sales/flight-attribution"
    ]
  },
  {
    "key": "salesTransportBookingNew",
    "path": "/sales/transport-bookings/new",
    "sectionKey": null,
    "frontend": "new",
    "menu": false,
    "activeMenuKey": "salesTransportBookings",
    "routePermission": "sales:transport-booking:write",
    "matchPatterns": [
      "/sales/transport-bookings/new"
    ]
  },
  {
    "key": "salesTransportBookingDetail",
    "path": "/sales/transport-bookings/detail",
    "sectionKey": null,
    "frontend": "new",
    "menu": false,
    "activeMenuKey": "salesTransportBookings",
    "routePermission": "sales:transport-booking:read",
    "matchPatterns": [
      "/sales/transport-bookings/detail"
    ]
  },
  {
    "key": "salesReceivables",
    "path": "/sales/receivables",
    "sectionKey": "sales",
    "frontend": "old",
    "menu": true,
    "menuLabel": "应收与收款",
    "menuIconKey": "reconciliation",
    "menuOrder": 40,
    "navigatePath": "/sales/receivables",
    "routePermission": "sales:revenue:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/sales/receivables"
    ]
  },
  {
    "key": "salesCargoReport",
    "path": "/sales/cargo-report",
    "sectionKey": "sales",
    "frontend": "old",
    "menu": true,
    "menuLabel": "货量报告",
    "menuIconKey": "chart-bar",
    "menuOrder": 11,
    "navigatePath": "/sales/cargo-report",
    "routePermission": "sales:cargo:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/sales/cargo-report"
    ]
  },
  {
    "key": "salesIataFuelPrices",
    "path": "/sales/iata-fuel-prices",
    "sectionKey": "sales",
    "frontend": "old",
    "menu": true,
    "menuLabel": "IATA 油价管理",
    "menuIconKey": "dollar",
    "menuOrder": 50,
    "navigatePath": "/sales/iata-fuel-prices",
    "routePermission": "sales:fuel-price:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/sales/iata-fuel-prices"
    ]
  },
  {
    "key": "salesExternalCrawlConfigLegacy",
    "path": "/sales/external-crawl-config",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "activeMenuKey": "settlementExternalCrawlConfig",
    "routePermission": "settlement:external-crawl:manage",
    "matchPatterns": [
      "/sales/external-crawl-config"
    ]
  },
  {
    "key": "schedulesEditor",
    "path": "/flightSchedule/editor/new",
    "sectionKey": "schedules",
    "frontend": "old",
    "menu": true,
    "menuLabel": "编辑计划",
    "menuIconKey": "calendar",
    "menuOrder": 10,
    "navigatePath": "/flightSchedule/editor",
    "routePermission": "schedule:update",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/flightSchedule/editor",
      "/flightSchedule/editor/new",
      "/flightSchedule/editor/:id"
    ]
  },
  {
    "key": "scheduleEditorRedirect",
    "path": "/flightSchedule/editor",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "activeMenuKey": "schedulesEditor",
    "routePermission": null,
    "matchPatterns": [
      "/flightSchedule/editor"
    ]
  },
  {
    "key": "scheduleEditorDetail",
    "path": "/flightSchedule/editor/:id",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "activeMenuKey": "schedulesEditor",
    "routePermission": "schedule:update",
    "matchPatterns": [
      "/flightSchedule/editor/:id"
    ]
  },
  {
    "key": "schedulesLegacyDrafts",
    "path": "/flightSchedule/drafts",
    "sectionKey": "schedules",
    "frontend": "old",
    "menu": true,
    "menuLabel": "草稿计划",
    "menuIconKey": "clock-circle",
    "menuOrder": 20,
    "navigatePath": "/flightSchedule/drafts",
    "routePermission": "schedule:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/flightSchedule/drafts"
    ]
  },
  {
    "key": "schedulesDrafts",
    "path": "/flightSchedule/v2/drafts",
    "sectionKey": "schedules",
    "frontend": "old",
    "menu": true,
    "menuLabel": "航班计划 V2",
    "menuIconKey": "calendar",
    "menuOrder": 25,
    "navigatePath": "/flightSchedule/v2/drafts",
    "routePermission": "schedule:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/flightSchedule/v2/drafts",
      "/flightSchedule/v2/drafts/:draftId"
    ]
  },
  {
    "key": "scheduleDraftsV21",
    "path": "/flight-schedule",
    "sectionKey": "schedules",
    "frontend": "new",
    "menu": true,
    "menuLabel": "航班计划 V2.1",
    "menuIconKey": "calendar",
    "menuOrder": 26,
    "navigatePath": "/flight-schedule",
    "routePermission": "schedule:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/flight-schedule",
      "/flight-schedule/:draftId"
    ]
  },
  {
    "key": "scheduleDraftV21Detail",
    "path": "/flight-schedule/:draftId",
    "sectionKey": null,
    "frontend": "new",
    "menu": false,
    "activeMenuKey": "scheduleDraftsV21",
    "routePermission": "schedule:read",
    "matchPatterns": [
      "/flight-schedule/:draftId"
    ]
  },
  {
    "key": "scheduleDraftDetail",
    "path": "/flightSchedule/v2/drafts/:draftId",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "activeMenuKey": "schedulesDrafts",
    "routePermission": "schedule:read",
    "matchPatterns": [
      "/flightSchedule/v2/drafts/:draftId"
    ]
  },
  {
    "key": "schedulesList",
    "path": "/flightSchedule/list",
    "sectionKey": "schedules",
    "frontend": "old",
    "menu": true,
    "menuLabel": "正式计划",
    "menuIconKey": "calendar",
    "menuOrder": 30,
    "navigatePath": "/flightSchedule/list",
    "routePermission": [
      "airline_schedule_ingest:read",
      "schedule_official:read"
    ],
    "menuPermission": null,
    "permissionMatch": "any",
    "matchPatterns": [
      "/flightSchedule/list"
    ]
  },
  {
    "key": "flightMonitor",
    "path": "/operation/flight-monitor",
    "sectionKey": "operation",
    "frontend": "old",
    "menu": true,
    "menuLabel": "航班监控",
    "menuIconKey": "monitor",
    "menuOrder": 10,
    "navigatePath": "/operation/flight-monitor",
    "routePermission": [
      "flight_operation:read",
      "flight_operation:read_basic"
    ],
    "menuPermission": null,
    "permissionMatch": "any",
    "matchPatterns": [
      "/operation/flight-monitor"
    ]
  },
  {
    "key": "operationControlV2",
    "path": "/operation/operation-control",
    "sectionKey": "operation",
    "frontend": "old",
    "menu": false,
    "menuLabel": "运行控制 V2",
    "menuIconKey": "control",
    "menuOrder": 15,
    "navigatePath": "/operation/operation-control",
    "routePermission": "flight_operation:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/operation/operation-control"
    ]
  },
  {
    "key": "operationControlV21",
    "path": "/operation-control",
    "sectionKey": "operation",
    "frontend": "new",
    "menu": true,
    "menuLabel": "航班监控 V2.1",
    "menuIconKey": "monitor",
    "menuOrder": 16,
    "navigatePath": "/operation-control",
    "routePermission": "flight_operation:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/operation-control"
    ]
  },
  {
    "key": "effectiveSupplier",
    "path": "/operation-control/effective-suppliers",
    "sectionKey": "operation",
    "frontend": "new",
    "menu": true,
    "menuLabel": "机场服务商配置",
    "menuIconKey": "settings",
    "menuOrder": 17,
    "navigatePath": "/operation-control/effective-suppliers",
    "routePermission": [
      "flight_operation:read",
      "contract:read"
    ],
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/operation-control/effective-suppliers"
    ]
  },
  {
    "key": "dashboard",
    "path": "/dashboard",
    "sectionKey": "workspace",
    "frontend": "old",
    "menu": true,
    "menuLabel": "仪表盘",
    "menuIconKey": "chart-bar",
    "menuOrder": 10,
    "navigatePath": "/dashboard",
    "routePermission": null,
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/dashboard"
    ]
  },
  {
    "key": "agReviewPage",
    "path": "/review/ag/:review_case_id",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "activeMenuKey": "flightMonitor",
    "routePermission": "ag:review",
    "matchPatterns": [
      "/review/ag/:review_case_id"
    ]
  },
  {
    "key": "permitRequestList",
    "path": "/operation/permit-requests",
    "sectionKey": "operation",
    "frontend": "old",
    "menu": true,
    "menuLabel": "许可申请查询",
    "menuIconKey": "safety-certificate",
    "menuOrder": 20,
    "navigatePath": "/operation/permit-requests",
    "routePermission": "flight_operation:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/operation/permit-requests"
    ]
  },
  {
    "key": "actionItemList",
    "path": "/operation/action-items",
    "sectionKey": "operation",
    "frontend": "old",
    "menu": true,
    "menuLabel": "AI行动项管理",
    "menuIconKey": "check-square",
    "menuOrder": 30,
    "navigatePath": "/operation/action-items",
    "routePermission": "flight_operation:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/operation/action-items"
    ]
  },
  {
    "key": "screenLeft",
    "path": "/operation/screen-left",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "routePermission": "operation:screen:view",
    "matchPatterns": [
      "/operation/screen-left"
    ]
  },
  {
    "key": "screenRight",
    "path": "/operation/screen-right",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "routePermission": "operation:screen:view",
    "matchPatterns": [
      "/operation/screen-right"
    ]
  },
  {
    "key": "flightMap",
    "path": "/operation/flight-map",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "routePermission": "operation:screen:view",
    "matchPatterns": [
      "/operation/flight-map"
    ]
  },
  {
    "key": "uldManagement",
    "path": "/uld-management",
    "sectionKey": "uld",
    "frontend": "old",
    "menu": true,
    "menuLabel": "ULD 综合管理",
    "menuIconKey": "code-sandbox",
    "menuOrder": 10,
    "navigatePath": "/uld-management",
    "routePermission": "uld:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/uld-management"
    ]
  },
  {
    "key": "ucmManagement",
    "path": "/ucm-management",
    "sectionKey": "uld",
    "frontend": "old",
    "menu": true,
    "menuLabel": "UCM 报文管理",
    "menuIconKey": "message",
    "menuOrder": 20,
    "navigatePath": "/ucm-management",
    "routePermission": "uld:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/ucm-management"
    ]
  },
  {
    "key": "uldStatistics",
    "path": "/uld-statistics",
    "sectionKey": "uld",
    "frontend": "old",
    "menu": true,
    "menuLabel": "ULD 统计分析",
    "menuIconKey": "chart-bar",
    "menuOrder": 30,
    "navigatePath": "/uld-statistics",
    "routePermission": "uld:statistics:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/uld-statistics"
    ]
  },
  {
    "key": "uldTagManagement",
    "path": "/uld-tag-management",
    "sectionKey": "uld",
    "frontend": "old",
    "menu": true,
    "menuLabel": "ULD 标签管理",
    "menuIconKey": "tags",
    "menuOrder": 40,
    "navigatePath": "/uld-tag-management",
    "routePermission": "uld:tag:manage",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/uld-tag-management"
    ]
  },
  {
    "key": "uldHistory",
    "path": "/uld-history",
    "sectionKey": "uld",
    "frontend": "old",
    "menu": true,
    "menuLabel": "ULD 历史记录",
    "menuIconKey": "history",
    "menuOrder": 50,
    "navigatePath": "/uld-history",
    "routePermission": "uld:history:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/uld-history"
    ]
  },
  {
    "key": "uldStockAlert",
    "path": "/uld-stock-alert",
    "sectionKey": "uld",
    "frontend": "old",
    "menu": true,
    "menuLabel": "ULD 库存预警",
    "menuIconKey": "bell",
    "menuOrder": 60,
    "navigatePath": "/uld-stock-alert",
    "routePermission": "uld:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/uld-stock-alert"
    ]
  },
  {
    "key": "uldOcrManagement",
    "path": "/uld-ocr-management",
    "sectionKey": "uld",
    "frontend": "old",
    "menu": true,
    "menuLabel": "复称清单解析",
    "menuIconKey": "scan",
    "menuOrder": 70,
    "navigatePath": "/uld-ocr-management",
    "routePermission": "uld:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/uld-ocr-management"
    ]
  },
  {
    "key": "apBatches",
    "path": "/settlement/ap-batches",
    "sectionKey": "settlement",
    "frontend": "old",
    "menu": true,
    "menuLabel": "账单批次上传",
    "menuIconKey": "upload",
    "menuOrder": 10,
    "navigatePath": "/settlement/ap-batches",
    "routePermission": "settlement_ap_invoice_data_source:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/settlement/ap-batches"
    ]
  },
  {
    "key": "apWorkbench",
    "path": "/settlement/ap-workbench",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "pageLabel": "账单对账工作台",
    "activeMenuKey": "apBatches",
    "routePermission": "settlement_ap_invoice_data_source:read",
    "matchPatterns": [
      "/settlement/ap-workbench"
    ]
  },
  {
    "key": "invoiceDataSources",
    "path": "/settlement/invoice-data-sources",
    "sectionKey": "settlement",
    "frontend": "old",
    "menu": true,
    "menuLabel": "应付账单上传",
    "menuIconKey": "cloud-upload",
    "menuOrder": 20,
    "navigatePath": "/settlement/invoice-data-sources",
    "routePermission": "settlement_ap_invoice_data_source:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/settlement/invoice-data-sources"
    ]
  },
  {
    "key": "invoices",
    "path": "/settlement/invoices",
    "sectionKey": "settlement",
    "frontend": "old",
    "menu": true,
    "menuLabel": "账单列表",
    "menuIconKey": "reconciliation",
    "menuOrder": 30,
    "navigatePath": "/settlement/invoices",
    "routePermission": "settlement:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/settlement/invoices"
    ]
  },
  {
    "key": "salesRoutes",
    "path": "/settlement/sales-routes",
    "sectionKey": "settlement",
    "frontend": "old",
    "menu": true,
    "menuLabel": "销售航线管理",
    "menuIconKey": "node-index",
    "menuOrder": 40,
    "navigatePath": "/settlement/sales-routes",
    "routePermission": "settlement:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/settlement/sales-routes"
    ]
  },
  {
    "key": "batchCalculations",
    "path": "/settlement/batch-calculations",
    "sectionKey": "settlement",
    "frontend": "old",
    "menu": true,
    "menuLabel": "批次核算管理",
    "menuIconKey": "calculator",
    "menuOrder": 50,
    "navigatePath": "/settlement/batch-calculations",
    "routePermission": "settlement:create",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/settlement/batch-calculations",
      "/settlement/batch-calculations/create",
      "/settlement/batch-calculations/:id"
    ],
    "badgeKey": "batchPendingCount",
    "badgeTooltipKey": "batchPendingDetail"
  },
  {
    "key": "batchCalculationCreate",
    "path": "/settlement/batch-calculations/create",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "activeMenuKey": "batchCalculations",
    "routePermission": "settlement:create",
    "matchPatterns": [
      "/settlement/batch-calculations/create"
    ]
  },
  {
    "key": "batchCalculationDetail",
    "path": "/settlement/batch-calculations/:id",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "activeMenuKey": "batchCalculations",
    "routePermission": "settlement:create",
    "matchPatterns": [
      "/settlement/batch-calculations/:id"
    ]
  },
  {
    "key": "profitReports",
    "path": "/settlement/profit-reports",
    "sectionKey": "settlement",
    "frontend": "old",
    "menu": true,
    "menuLabel": "成本报表管理",
    "menuIconKey": "chart-bar",
    "menuOrder": 60,
    "navigatePath": "/settlement/profit-reports",
    "routePermission": "settlement:read",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/settlement/profit-reports"
    ]
  },
  {
    "key": "legCostManagement",
    "path": "/settlement/leg-cost",
    "sectionKey": "settlement",
    "frontend": "old",
    "menu": true,
    "menuLabel": "航段费用",
    "menuIconKey": "reconciliation",
    "menuOrder": 70,
    "navigatePath": "/settlement/leg-cost",
    "routePermission": [
      "settlement:read",
      "settlement:allocate",
      "settlement:acmi",
      "settlement:commission"
    ],
    "menuPermission": null,
    "permissionMatch": "any",
    "matchPatterns": [
      "/settlement/leg-cost",
      "/settlement/cost-allocation",
      "/settlement/acmi-entry",
      "/settlement/commission-entry"
    ]
  },
  {
    "key": "costAllocationLegacy",
    "path": "/settlement/cost-allocation",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "activeMenuKey": "legCostManagement",
    "routePermission": "settlement:allocate",
    "matchPatterns": [
      "/settlement/cost-allocation"
    ]
  },
  {
    "key": "acmiEntryLegacy",
    "path": "/settlement/acmi-entry",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "activeMenuKey": "legCostManagement",
    "routePermission": "settlement:acmi",
    "matchPatterns": [
      "/settlement/acmi-entry"
    ]
  },
  {
    "key": "commissionEntryLegacy",
    "path": "/settlement/commission-entry",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "activeMenuKey": "legCostManagement",
    "routePermission": "settlement:commission",
    "matchPatterns": [
      "/settlement/commission-entry"
    ]
  },
  {
    "key": "statisticsDashboard",
    "path": "/settlement/statistics-dashboard",
    "sectionKey": "settlement",
    "frontend": "old",
    "menu": true,
    "menuLabel": "统计报表",
    "menuIconKey": "fund",
    "menuOrder": 110,
    "navigatePath": "/settlement/statistics-dashboard",
    "routePermission": "statistics:dashboard:view",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/settlement/statistics-dashboard"
    ]
  },
  {
    "key": "fuelReports",
    "path": "/settlement/fuel-reports",
    "sectionKey": "settlement",
    "frontend": "old",
    "menu": true,
    "menuLabel": "航班燃油明细",
    "menuIconKey": "dollar",
    "menuOrder": 115,
    "navigatePath": "/settlement/fuel-reports",
    "routePermission": "statistics:fuel",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/settlement/fuel-reports"
    ]
  },
  {
    "key": "flightCostManagementWorkbench",
    "path": "/settlement/flight-cost-workbench",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "activeMenuKey": null,
    "routePermission": "settlement:read",
    "matchPatterns": [
      "/settlement/flight-cost-workbench"
    ]
  },
  {
    "key": "flightCostManagement",
    "path": "/settlement/flight-cost",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "activeMenuKey": null,
    "routePermission": "settlement:read",
    "matchPatterns": [
      "/settlement/flight-cost"
    ]
  },
  {
    "key": "legDetail",
    "path": "/settlement/leg-detail/:taskId",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "activeMenuKey": "legCostManagement",
    "routePermission": "settlement:read",
    "matchPatterns": [
      "/settlement/leg-detail/:taskId"
    ]
  },
  {
    "key": "flightRecordLog",
    "path": "/settlement/flight-record-log",
    "sectionKey": "settlement",
    "frontend": "old",
    "menu": true,
    "menuLabel": "飞行记录管理",
    "menuIconKey": "history",
    "menuOrder": 75,
    "navigatePath": "/settlement/flight-record-log",
    "routePermission": "settlement:import",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/settlement/flight-record-log"
    ]
  },
  {
    "key": "settlementExternalCrawlConfig",
    "path": "/settlement/external-crawl-config",
    "sectionKey": "settlement",
    "frontend": "old",
    "menu": true,
    "menuLabel": "燃油账单抓取",
    "menuIconKey": "cloud-upload",
    "menuOrder": 80,
    "navigatePath": "/settlement/external-crawl-config",
    "routePermission": "settlement:external-crawl:manage",
    "menuPermission": null,
    "permissionMatch": "all",
    "matchPatterns": [
      "/settlement/external-crawl-config"
    ]
  },
  {
    "key": "mailHubMailboxes",
    "path": "/mail-hub/mailboxes",
    "sectionKey": "mailHub",
    "frontend": "old",
    "menu": true,
    "menuLabel": "邮箱管理",
    "menuIconKey": "inbox",
    "menuOrder": 10,
    "navigatePath": "/mail-hub/mailboxes",
    "routePermission": [
      "mail_hub:mailbox_manage",
      "mail_hub:manage"
    ],
    "menuPermission": null,
    "permissionMatch": "any",
    "matchPatterns": [
      "/mail-hub/mailboxes",
      "/mail-hub/mailboxes/:id"
    ]
  },
  {
    "key": "mailHubMailboxDetail",
    "path": "/mail-hub/mailboxes/:id",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "activeMenuKey": "mailHubMailboxes",
    "routePermission": [
      "mail_hub:mailbox_manage",
      "mail_hub:manage"
    ],
    "matchPatterns": [
      "/mail-hub/mailboxes/:id"
    ]
  },
  {
    "key": "mailHubInbox",
    "path": "/mail-hub/inbox",
    "sectionKey": "mailHub",
    "frontend": "old",
    "menu": false,
    "menuLabel": "收件箱",
    "menuIconKey": "inbox",
    "menuOrder": 20,
    "navigatePath": "/mail-hub/inbox",
    "routePermission": [
      "mail_hub:inbox_view",
      "mail_hub:mailbox_manage",
      "mail_hub:manage"
    ],
    "menuPermission": null,
    "permissionMatch": "any",
    "matchPatterns": [
      "/mail-hub/inbox",
      "/mail-hub/inbox/:receiptId",
      "/mail-hub/threads/:threadId"
    ]
  },
  {
    "key": "mailHubInboxDetail",
    "path": "/mail-hub/inbox/:receiptId",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "activeMenuKey": "mailHubInbox",
    "routePermission": [
      "mail_hub:inbox_view",
      "mail_hub:mailbox_manage",
      "mail_hub:manage"
    ],
    "matchPatterns": [
      "/mail-hub/inbox/:receiptId"
    ]
  },
  {
    "key": "mailHubThreadDetail",
    "path": "/mail-hub/threads/:threadId",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "activeMenuKey": "mailHubInbox",
    "routePermission": [
      "mail_hub:inbox_view",
      "mail_hub:mailbox_manage",
      "mail_hub:manage"
    ],
    "matchPatterns": [
      "/mail-hub/threads/:threadId"
    ]
  },
  {
    "key": "portalInbox",
    "path": "/inbox",
    "sectionKey": "mailHub",
    "frontend": "new",
    "menu": true,
    "menuLabel": "收件箱",
    "menuIconKey": "inbox",
    "menuOrder": 21,
    "navigatePath": "/inbox",
    "routePermission": [
      "mail_hub:inbox_view",
      "mail_hub:mailbox_manage",
      "mail_hub:manage"
    ],
    "menuPermission": null,
    "permissionMatch": "any",
    "matchPatterns": [
      "/inbox"
    ]
  },
  {
    "key": "mailHubOutbox",
    "path": "/mail-hub/outbox",
    "sectionKey": "mailHub",
    "frontend": "old",
    "menu": false,
    "menuLabel": "发件箱",
    "menuIconKey": "send",
    "menuOrder": 25,
    "navigatePath": "/mail-hub/outbox",
    "routePermission": [
      "mail_hub:outbox_view",
      "mail_hub:mailbox_manage",
      "mail_hub:manage"
    ],
    "menuPermission": null,
    "permissionMatch": "any",
    "matchPatterns": [
      "/mail-hub/outbox"
    ]
  },
  {
    "key": "portalMailCompose",
    "path": "/mail-compose",
    "sectionKey": "mailHub",
    "frontend": "new",
    "menu": true,
    "menuLabel": "邮件撰写",
    "menuIconKey": "send",
    "menuOrder": 27,
    "navigatePath": "/mail-compose",
    "routePermission": [
      "mail_hub:outbox_view",
      "mail_hub:mailbox_manage",
      "mail_hub:manage"
    ],
    "menuPermission": null,
    "permissionMatch": "any",
    "matchPatterns": [
      "/mail-compose"
    ]
  },
  {
    "key": "portalOutbox",
    "path": "/outbox",
    "sectionKey": "mailHub",
    "frontend": "new",
    "menu": true,
    "menuLabel": "发件箱",
    "menuIconKey": "send",
    "menuOrder": 26,
    "navigatePath": "/outbox",
    "routePermission": [
      "mail_hub:outbox_view",
      "mail_hub:mailbox_manage",
      "mail_hub:manage"
    ],
    "menuPermission": null,
    "permissionMatch": "any",
    "matchPatterns": [
      "/outbox"
    ]
  },
  {
    "key": "portalMailTemplates",
    "path": "/mail-templates",
    "sectionKey": "mailHub",
    "frontend": "new",
    "menu": true,
    "menuLabel": "邮件模板",
    "menuIconKey": "file-text",
    "menuOrder": 27,
    "navigatePath": "/mail-templates",
    "routePermission": "mail_hub:template:manage",
    "menuPermission": "mail_hub:template:manage",
    "permissionMatch": "all",
    "matchPatterns": [
      "/mail-templates"
    ]
  },
  {
    "key": "mailHubClassificationGovernance",
    "path": "/mail-hub/ops/classification-governance",
    "sectionKey": "mailHub",
    "frontend": "old",
    "menu": true,
    "menuLabel": "运维与审计 / 分类治理",
    "menuIconKey": "tags",
    "menuOrder": 30,
    "navigatePath": "/mail-hub/ops/classification-governance",
    "routePermission": [
      "mail_hub:ops_view",
      "mail_hub:classification_view",
      "mail_hub:classification_manage",
      "mail_hub:manage"
    ],
    "menuPermission": null,
    "permissionMatch": "any",
    "matchPatterns": [
      "/mail-hub/ops/classification-governance"
    ]
  },
  {
    "key": "mailHubPipelineGovernance",
    "path": "/mail-hub/ops/pipeline-governance",
    "sectionKey": "mailHub",
    "frontend": "old",
    "menu": true,
    "menuLabel": "运维与审计 / Pipeline 任务配置",
    "menuIconKey": "node-index",
    "menuOrder": 40,
    "navigatePath": "/mail-hub/ops/pipeline-governance",
    "routePermission": [
      "mail_hub:ops_view",
      "mail_hub:pipeline_manage",
      "mail_hub:manage"
    ],
    "menuPermission": null,
    "permissionMatch": "any",
    "matchPatterns": [
      "/mail-hub/ops/pipeline-governance"
    ]
  },
  {
    "key": "mailHubWorkItems",
    "path": "/mail-hub/ops/work-items",
    "sectionKey": "mailHub",
    "frontend": "old",
    "menu": true,
    "menuLabel": "运维与审计 / Work Items",
    "menuIconKey": "node-index",
    "menuOrder": 50,
    "navigatePath": "/mail-hub/ops/work-items",
    "routePermission": [
      "mail_hub:ops_view",
      "mail_hub:manage"
    ],
    "menuPermission": null,
    "permissionMatch": "any",
    "matchPatterns": [
      "/mail-hub/ops/work-items",
      "/mail-hub/ops/work-items/:id"
    ]
  },
  {
    "key": "mailHubWorkItemDetail",
    "path": "/mail-hub/ops/work-items/:id",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "activeMenuKey": "mailHubWorkItems",
    "routePermission": [
      "mail_hub:ops_view",
      "mail_hub:manage"
    ],
    "matchPatterns": [
      "/mail-hub/ops/work-items/:id"
    ]
  },
  {
    "key": "login",
    "path": "/login",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "routePermission": null,
    "matchPatterns": [
      "/login"
    ]
  },
  {
    "key": "root",
    "path": "/",
    "sectionKey": null,
    "frontend": "old",
    "menu": false,
    "routePermission": null,
    "matchPatterns": [
      "/"
    ]
  }
];

module.exports = { sections, routes };
